import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import {
  CourtFileNumbersResponse,
  CourtFileNumbersResponseSnake,
} from '@shared/interfaces';
import { getStateCourt } from '@shared/utils';
import { map, Observable } from 'rxjs';
import { objectToCamel } from 'ts-case-convert';

@Injectable({ providedIn: 'root' })
export class CourtFileNumberApiService {
  private readonly _http = inject(HttpClient);
  private readonly _tenantService = inject(TenantFacadeService);
  private readonly _court = getStateCourt();

  public getCourtFileNumbers(): Observable<CourtFileNumbersResponse> {
    return this._http
      .get<CourtFileNumbersResponseSnake>(
        `${this._tenantService.tenantApiUrl()}/courts/${this._court().id}/file-number/`,
      )
      .pipe(map((response) => objectToCamel(response)));
  }
}
